import { ModuleType } from 'app/library/module/enums/moduleType.enum';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { User } from 'app/projects/user/src/lib/models/user';
import { ExtendedAttributeCategoryEnum } from '../enums/extended-attribute-category.enum';
import { IEditExtendedAttributeValue } from '../interfaces/edit-extended-attribute-value.interface';
import { ExtendedAttribute } from '../models/extended-attribute';

export class SetExtendedAttribute {
    static readonly type = '[ExtendedAttribute] SetExtendedAttribute';

    constructor(public payload: ExtendedAttribute) {}
}

export class UnsetExtendedAttribute {
    static readonly type = '[ExtendedAttribute] UnsetExtendedAttribute';
}

export class FetchExtendedAttribute {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttribute';

    constructor(public payload: string) {}
}

export class FetchExtendedAttributeSuccess {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttributeSuccess';

    constructor(public payload: ExtendedAttribute) {}
}

export class FetchExtendedAttributeFailure {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttributeFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateExtendedAttribute {
    static readonly type = '[ExtendedAttribute] CreateExtendedAttribute';

    constructor(public payload: ExtendedAttribute) {}
}

export class CreateExtendedAttributeSuccess {
    static readonly type = '[ExtendedAttribute] CreateExtendedAttributeSuccess';

    constructor(public payload: ExtendedAttribute) {}
}

export class CreateExtendedAttributeFailure {
    static readonly type = '[ExtendedAttribute] CreateExtendedAttributeFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateExtendedAttribute {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttribute';

    constructor(public payload: ExtendedAttribute) {}
}

export class UpdateExtendedAttributeSuccess {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeSuccess';

    constructor(public payload: ExtendedAttribute) {}
}

export class UpdateExtendedAttributeFailure {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class UpdateExtendedAttributeTranslations {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeTranslations';

    constructor(public payload: ExtendedAttribute) {}
}

export class UpdateExtendedAttributeTranslationsSuccess {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeTranslationsSuccess';

    constructor(public payload: ExtendedAttribute) {}
}

export class UpdateExtendedAttributeTranslationsFailure {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeTranslationsFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteExtendedAttribute {
    static readonly type = '[ExtendedAttribute] DeleteExtendedAttribute';

    constructor(public payload: string) {}
}

export class DeleteExtendedAttributeSuccess {
    static readonly type = '[ExtendedAttribute] DeleteExtendedAttributeSuccess';

    constructor(public payload: string) {}
}

export class DeleteExtendedAttributeFailure {
    static readonly type = '[ExtendedAttribute] DeleteExtendedAttributeFailure';

    constructor(public payload: string) {}
}

export class SetExtendedAttributes {
    static readonly type = '[ExtendedAttribute] SetExtendedAttributes';

    constructor(public payload: ExtendedAttribute[]) {}
}

export class FetchExtendedAttributes {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttributes';
}

export class FetchExtendedAttributesSuccess {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttributesSuccess';
}

export class FetchExtendedAttributesFailure {
    static readonly type = '[ExtendedAttribute] FetchExtendedAttributesFailure';
}

export class ToggleSelectedExtendedAttribute {
    static readonly type = '[ExtendedAttribute] ToggleSelectedExtendedAttribute';

    constructor(public payload: string) {}
}

export class SelectFilteredExtendedAttributes {
    static readonly type = '[ExtendedAttribute] SelectFilteredExtendedAttributes';
}

export class DeselectSelectedExtendedAttributes {
    static readonly type = '[ExtendedAttribute] DeselectSelectedExtendedAttributes';
}

export class SearchExtendedAttributes {
    static readonly type = '[ExtendedAttribute] SearchExtendedAttributes';

    constructor(public payload: string) {}
}

export class FetchAllAdminExtendedAttributes {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributes';

    constructor(
        public payload: {
            categories: ExtendedAttributeCategoryEnum[];
            enabledForFilter?: string;
        }
    ) {}
}

export class FetchAllAdminExtendedAttributesSuccess {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributesSuccess';
}

export class FetchAllAdminExtendedAttributesFailure {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributesFailure';
}

export class FetchAllAdminExtendedAttributesByModuleType {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributesByModuleType';

    constructor(
        public payload: {
            category: ExtendedAttributeCategoryEnum;
            enabledForFilter: string;
        }
    ) {}
}

export class FetchAllAdminExtendedAttributesByModuleTypeSuccess {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributesByModuleTypeSuccess';

    constructor(public payload: ExtendedAttribute[]) {}
}

export class FetchAllAdminExtendedAttributesByModuleTypeFailure {
    static readonly type = '[ExtendedAttribute] FetchAllAdminExtendedAttributesByModuleTypeFailure';
}

export class SetExtendedAttributeOptionsById {
    static readonly type = '[ExtendedAttribute] SetExtendedAttributeOptionsById';

    constructor(public payload: string) {}
}

export class FetchAllExtendedAttributes {
    static readonly type = '[ExtendedAttribute] FetchAllExtendedAttributes';

    constructor(
        public payload: {
            categories: ExtendedAttributeCategoryEnum[];
            enabledForFilter?: ModuleType;
        }
    ) {}
}

export class FetchAllExtendedAttributesSuccess {
    static readonly type = '[ExtendedAttribute] FetchAllExtendedAttributesSuccess';
}

export class FetchAllExtendedAttributesFailure {
    static readonly type = '[ExtendedAttribute] FetchAllExtendedAttributesFailure';
}

export class UpdateExtendedAttributeValue {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeValue';

    constructor(public payload: IEditExtendedAttributeValue) {}
}

export class UpdateExtendedAttributeValueSuccess {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeValueSuccess';

    constructor(public payload: User) {}
}

export class UpdateExtendedAttributeValueFailure {
    static readonly type = '[ExtendedAttribute] UpdateExtendedAttributeValueFailure';
}
